import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from '@chakra-ui/react';
export const UiContainer = ({ children, size, marginBottom, marginTop, }) => {
    const _size = size ?? 'full';
    return (_jsx(Container, { maxWidth: `container.${_size}`, px: _size === 'full' ? '0' : undefined, marginBottom: marginBottom ?? undefined, marginTop: marginTop ?? undefined, children: children }));
};
